import React from 'react'

export const NavbarSpace = () => {
  return (
    <li className="space"></li>
  )
}
